import styled from 'styled-components';

const value = styled.h1`
  font-size: 3rem;
`;

const Text = {
  Value: value,
};

export default Text;
